import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';

import {EmailNotificationToggleComponent} from '../email-notification-toggle/email-notification-toggle.component';

@Component({
    selector: 'app-elements-email-notification-settings',
    templateUrl: './elements-email-notification-settings.component.html',
    styleUrls: ['./elements-email-notification-settings.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [EmailNotificationToggleComponent]
})
export class ElementsEmailNotificationSettingsComponent {
    @Input() value: boolean;
    @Output() toggleSetting: EventEmitter<any> = new EventEmitter();
}
